import { NgIf, NgFor, NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { RouterLink } from '@angular/router';
import { footers } from 'src/_lib/interfaces/footer.interface';
import { environment } from 'src/environments/environment.prod';
import { BrowserService } from 'src/_lib/service/browser.service';
import { DynamicThemeClassService } from 'src/_lib/service/dynamic-theme-class.service';

@Component({
  selector: 'app-top-footer-ch1',
  templateUrl: './top-footer-ch1.component.html',
  styleUrls: ['./top-footer-ch1.component.scss'],
  standalone: true,
  imports: [NgIf, NgFor , NgClass , RouterLink],
encapsulation: ViewEncapsulation.None
})
export class TopFooterCh1Component {
  cdnImagePath: string = environment.cdnImagePath;
  chTheme2 = environment.chTheme2;
  chTheme5 = environment.chTheme5;
  chTheme7 = environment.chTheme7;
  chTheme9 = environment.chTheme9;
  chTheme11 = environment.chTheme11;

  @Input() footerdata!: footers;
  @Input() footerwarning!: boolean;
  @Input() showContactDetails = false;
  @Input() isExternal!: (url: string) => boolean;
  @Output() linkClick = new EventEmitter<{
    event: Event;
    navLink: string;
    navname: string;
  }>();

  constructor(private browser: BrowserService,  private dynamicThemeClassService: DynamicThemeClassService) { }
  scrollTop() {
  this.browser.window?.scrollTo({ top: 0, behavior: 'smooth' });
}

  onClick(event: Event, navLink: string, navname: string) {
    this.linkClick.emit({ event, navLink, navname });
  }
  
    themeClass(divName: string): string {
      return this.dynamicThemeClassService.generateClassName(divName);
    }
}